import styled from '@emotion/styled'
import {
  Container,
  Box,
  Button,
  Typography,
  Chip,
  Card,
  Paper,
  Grid,
} from '@mui/material'
import { typography } from '@resiliatech/birdsong'
import { colors } from '../../../../Themes/Colors'

export const PageContainer = styled(Container)`
  padding-top: 24px;
  padding-bottom: 24px;
`

export const HeaderSection = styled(Box)`
  margin-bottom: 32px;
`

export const BackButton = styled(Button)`
  margin-bottom: 16px;
`

export const TitleSection = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
`

export const Title = styled(Typography)`
  ${typography.up5.semiBoldSans}
  color: ${colors.darkGrey};
  margin-bottom: 8px;
`

export const Subtitle = styled(Typography)`
  ${typography.up2.regularSans}
  color: ${colors.mediumGrey};
`

const getStatusBackgroundColor = (status: 'active' | 'disabled' | 'test') => {
  if (status === 'active') return colors.completedGreen
  if (status === 'test') return colors.lightYellow
  return colors.lightRed
}

const getStatusColor = (status: 'active' | 'disabled' | 'test') => {
  if (status === 'active') return colors.darkGreen
  if (status === 'test') return colors.paletteOrange
  return colors.red
}

export const StatusChip = styled(Chip)<{
  status: 'active' | 'disabled' | 'test'
}>`
  margin-left: 16px;
  background-color: ${({ status }) => getStatusBackgroundColor(status)};
  color: ${({ status }) => getStatusColor(status)};
`

export const StatCard = styled(Card)`
  height: 100%;
  text-align: center;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`

export const StatIcon = styled(Box)`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  color: ${colors.resiliaBlue};
`

export const StatValue = styled(Typography)`
  ${typography.up5.semiBoldSans}
  color: ${colors.darkGrey};
  margin-bottom: 4px;
`

export const StatLabel = styled(Typography)`
  ${typography.up1.regularSans}
  color: ${colors.mediumGrey};
`

export const SectionTitle = styled(Typography)`
  ${typography.up3.semiBoldSans}
  color: ${colors.darkGrey};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const InfoCard = styled(Card)`
  margin-bottom: 24px;
`

export const InfoGrid = styled(Grid)`
  padding: 16px;
`

export const InfoItem = styled(Box)`
  margin-bottom: 16px;
`

export const InfoLabel = styled(Typography)`
  ${typography.up1.regularSans}
  color: ${colors.mediumGrey};
  margin-bottom: 4px;
`

export const InfoValue = styled(Typography)`
  ${typography.up2.regularSans}
  color: ${colors.darkGrey};
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ScrollablePanel = styled(Paper)`
  max-height: 400px;
  overflow-y: auto;
  padding: 16px;
  background-color: ${colors.lightestGrey};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.lightGrey};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.mediumGrey};
    border-radius: 4px;

    &:hover {
      background: ${colors.darkGrey};
    }
  }
`

export const EmptyState = styled(Box)`
  text-align: center;
  padding: 48px 24px;
  color: ${colors.mediumGrey};
`

export const ActionBar = styled(Box)`
  position: sticky;
  bottom: 0;
  background-color: ${colors.resiliaWhite};
  border-top: 1px solid ${colors.lightGrey};
  padding: 16px 0;
  margin-top: 32px;
  display: flex;
  gap: 16px;
  justify-content: center;
`

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`

export const ErrorContainer = styled(Paper)`
  padding: 48px;
  text-align: center;
  background-color: ${colors.lightRed};
  color: ${colors.red};
`
